<script setup lang="ts">
import {MailCodeIcon, SettingsIcon, TriangleSquareCircleIcon, WaveSquareIcon} from "vue-tabler-icons";

const menuItems = computed(() => {
  const base = `/root`
  return ([
    {
      title: 'Workspaces',
      icon: TriangleSquareCircleIcon,
      to: `${base}/workspaces`
    },
    {
      title: 'Connections',
      icon: WaveSquareIcon,
      to: `${base}/connections`
    },
    {
      title: 'History',
      icon: MailCodeIcon,
      to: `${base}/history`
    },
    {
      title: 'Enterprise Plans',
      icon: SettingsIcon,
      to: `${base}/enterprise`
    }
  ]);
})
</script>

<style scoped>
.horizontalMenu {
  background-color: rgba(255,187,72, 0.7); /* Orange root color with 70% opacity */
}
</style>


<template>
  <MenuRouteBased title="Root" :items="menuItems"/>

</template>
